import React, { useState, useRef, useEffect } from "react";
import "../css/Login.css";
import { useNavigate, Link } from "react-router-dom";
import { showSuccessToast, showErrorToast } from "../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../utils/toastMessages";
import api from "../api";

const images = [
  // "/img/superadminbg1.png",
  "/img/superadminbg2.png",
  "/img/superadminbg5.png",
  "/img/superadminbg3.png",
  "/img/superadminbg4.png",
  "/img/superadminbg5.png",
];

const VerifyEmail = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputsRef = useRef([]);
  const [loading, setLoading] = useState(false);
  const email = sessionStorage.getItem("resetEmail");
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    // if (value && index < 5) inputsRef.current[index + 1]?.focus();
    // if (!value && index > 0) inputsRef.current[index - 1]?.focus();
    // Move focus only if user typed a new value (not deleting)
    if (value && index < otp.length - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const updatedOtp = [...otp];

      if (otp[index]) {
        // Delete the current value first
        updatedOtp[index] = "";
        setOtp(updatedOtp);
      } else if (index > 0) {
        // If current box is empty, go back
        inputsRef.current[index - 1]?.focus();
        updatedOtp[index - 1] = "";
        setOtp(updatedOtp);
      }
    } else if (e.key >= "0" && e.key <= "9") {
      // Direct key input fix for some mobile keyboards
      const updatedOtp = [...otp];
      updatedOtp[index] = e.key;
      setOtp(updatedOtp);
      if (index < otp.length - 1) {
        inputsRef.current[index + 1]?.focus();
      }
      e.preventDefault(); // Prevent double input on some Android devices
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    const code = otp.join("");
    if (code.length < 6) {
      showErrorToast(TOAST_MESSAGES.AUTH.ENTER_FULL_OTP);
      return;
    }

    setLoading(true);

    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/auth/verify-otp`,
        { email, otp: code }
      );

      const data = response.data;
      sessionStorage.setItem("resetToken", data.resetToken);

      showSuccessToast(data.message || TOAST_MESSAGES.AUTH.EMAIL_VERIFIED);
      navigate("/reset-password");
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        TOAST_MESSAGES.AUTH.EMAIL_VERIFICATION_FAILED;
      showErrorToast(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        {images.map((img, index) => (
          <div
            key={index}
            className={`bg-slide ${index === currentImage ? "active" : ""}`}
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
      </div>

      <div className="login-right d-flex flex-column justify-content-center align-items-start">
        {/* Fixed Logo */}
        <div className="logo-wrapper">
          <img
            className="zerobox-logo"
            src="/asset/Domatrix_Logo_White_crop.png"
            alt="Domatrix Logo"
          />
        </div>

        {/* Form below the logo */}
        <form
          className="login-form p-4  rounded-3 mx-auto mt-4"
          onSubmit={handleSubmit}
        >
          <h3 className="mb-3 text-center refresh-prompts fw-bolder ">
            Enter Verification Code
          </h3>
          <p className="text-center login-p mx-3 refresh-prompts">
            Enter the code that send to your email address
          </p>

          <div className="d-flex justify-content-between mx-4 mb-4">
            {otp.map((digit, index) => (
              <input
                key={index}
                type="text"
                inputMode="numeric"
                maxLength="1"
                className="form-control text-center mx-2 otp-input"
                value={digit}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                ref={(el) => (inputsRef.current[index] = el)}
                autoFocus={index === 0}
                disabled={loading}
              />
            ))}
          </div>

          <button type="submit" className="custom-btn w-100" disabled={loading}>
            {loading ? "Verifying..." : "Continue"}
          </button>

          {/* <div className="text-center mt-3">
            <Link to="/forgot-password" className="text-decoration-none small">
              Resend Code
            </Link>
          </div> */}
        </form>
      </div>
    </div>
  );
};

export default VerifyEmail;
